/* AppShell — full-height layout wrapper: AppHeader on top, content below.
   Ported from lib/shell.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { AppHeader } from './AppHeader';

export interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <AppHeader />
      <main
        className="grow"
        style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
      >
        {children}
      </main>
    </div>
  );
}

export default AppShell;
